import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import { COLORS } from '../../constants';

const { LAVENDER } = COLORS;

const AsnSwiper = styled(Swiper)`
  .swiper-pagination-bullet {
    border-radius: 1px;
    height: 3px;
    width: 10px;
    background: ${LAVENDER};
  }
  .swiper-pagination-bullet-active {
    width: 14px;
  }

  &.coverflow {
    .swiper-slide-prev {
      #comment {
        display: none;
      }
      .ant-image {
        height: 140px;
        width: 140px;
        img {
          height: 140px;
        }
      }
    }
    .swiper-slide-next {
      #comment {
        display: none;
      }
      .ant-image {
        height: 140px;
        width: 140px;
        img {
          height: 140px;
        }
      }
    }
    .swiper-slide {
      #comment {
        display: none;
      }
      display: flex;
      justify-content: center;
      .ant-image {
        height: 120px;
        width: 120px;
        img {
          height: 120px;
        }
      }
    }
    .swiper-wrapper {
      display: flex;
      align-items: center;
    }
    .swiper-slide-active {
      #comment {
        display: block;
      }
      .ant-image {
        height: 200px;
        width: 200px;
        margin-left: -24px;
        img {
          border: 3px solid ${LAVENDER};
          height: 200px;
        }
      }
    }
  }
`;

export default AsnSwiper;
